import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    current_version: UI_VERSION,
    new_version: null,
};
const slice = createSlice({
    name: 'update_version',
    initialState,
    reducers: {
        updateUpdateVersion: (state, action) => {
            state.new_version = action.payload;
        },
    },
});
export const { updateUpdateVersion } = slice.actions;
export const updateVersionReducer = slice.reducer;
